import Vue from "vue";
import Router from "vue-router";
import AppBemVindo from "@/views/AppBemVindo";
import AppLogin from "@/views/AppLogin";
import AppSemCadastro from "@/views/AppSemCadastro";
import AppPrivacidade from "@/views/AppPrivacidade";
import AppMain from "@/views/AppMain";
import AppMainDados from "@/views/AppMainDados";
import AppMainAgradecimentos from "@/views/AppMainAgradecimentos";
import AppMainFotos from "@/views/AppMainFotos";
import AdminCreateUser from "@/views/AdminCreateUser";
import AdminProjeto from "@/views/AdminProjeto";

Vue.use(Router);

const router = new Router({
  base: __dirname,
  mode: "history",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      name: "AppBemVindo",
      component: AppBemVindo
    },
    {
      path: "/login",
      name: "AppLogin",
      component: AppLogin
    },
    {
      path: "/semcadastro",
      name: "AppSemCadastro",
      component: AppSemCadastro
    },
    {
      path: "/privacidade",
      name: "AppPrivacidade",
      component: AppPrivacidade
    },
    {
      path: "/",
      component: AppMain,
      children: [
        {
          path: "dados",
          name: "AppMainDados",
          component: AppMainDados
        },
        {
          path: "agradecimentos",
          name: "AppMainAgradecimentos",
          component: AppMainAgradecimentos
        },
        {
          path: "fotos",
          name: "AppMainFotos",
          component: AppMainFotos
        }
      ]
    },
    {
      path: "/createuser",
      name: "AdminCreateUser",
      component: AdminCreateUser
    },
    {
      path: "/adminprojeto",
      name: "AdminProjeto",
      component: AdminProjeto
    },
    // Global redirect for 404
    {
      path: "*",
      redirect: "/",
      query: { code: 404, message: "Página não encontrada." }
    }
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js